import { TranslatableText } from '@dreryk/react-common';
import { TextEditor } from '@dreryk/react-components';
import { TextEditorValue } from '@dreryk/react-text-editor';

import { StyledPrescriptionVisitTemplatesTextarea } from '../PrescriptionVisitTemplatesForm.styled';
import {
   PrescriptionVisitTemplatesFormBean,
   PrescriptionVisitTemplatesFormController,
} from '../PrescriptionVisitTemplatesForm.types';

const TEXT_EDITOR_MAX_CONTENT_LENGTH = 10000;
const TEXT_EDITOR_MAX_HTML_CONTENT_LENGTH = 50000;

type TextEditorFieldName = Extract<
   keyof PrescriptionVisitTemplatesFormBean,
   'interview' | 'physicalExamination' | 'recommendations'
>;

type PrescriptionVisitTemplatesTextEditorFieldProps = Pick<
   PrescriptionVisitTemplatesFormController,
   'register' | 'control'
> & {
   readonly name: TextEditorFieldName;
   readonly label: TranslatableText;
   readonly placeholder: TranslatableText;
};

export const PrescriptionVisitTemplatesTextEditorField = (
   props: PrescriptionVisitTemplatesTextEditorFieldProps
): JSX.Element => {
   const handleChange = (value: TextEditorValue | null): void => {
      props.control.setValue(props.name, value);
   };

   const handleInitialValue = (): TextEditorValue | null => props.control.getValues(props.name);

   return (
      <StyledPrescriptionVisitTemplatesTextarea>
         <TextEditor
            controller={props.register(props.name, { maxLength: TEXT_EDITOR_MAX_CONTENT_LENGTH })}
            label={props.label}
            placeholder={props.placeholder}
            testId={props.name}
            maxLength={TEXT_EDITOR_MAX_CONTENT_LENGTH}
            maxHtmlLength={TEXT_EDITOR_MAX_HTML_CONTENT_LENGTH}
         >
            <TextEditor.ModalView
               testId={`${props.name}ModalView`}
               onChange={handleChange}
               initialValue={handleInitialValue}
               label={props.label}
               placeholder={props.placeholder}
               maxLength={TEXT_EDITOR_MAX_CONTENT_LENGTH}
            />
         </TextEditor>
      </StyledPrescriptionVisitTemplatesTextarea>
   );
};
